import {keyframes} from '@emotion/react'
import {remCalc} from '_themeUtils'
const animationUnderlineAfter = keyframes`
    0% {
        transform: translateX(0);
    }
    50% {
        transform: translateX(100%);
    }
    51% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0);
    }
`

const buttonSizes = {
    xs: 'buttonXs',
    sm: 'buttonSm',
    md: 'buttonMd',
    lg: 'buttonLg',
}

const ctaButton = {
    CtaButton: {
        baseStyle: {
            linkWrapper: {
                position: 'relative',
                textTransform: 'uppercase',
                overflow: 'hidden',
                borderColor: 'color.text.black',
                mt: 'spacing.2',
                _hover: {
                    textDecoration: 'none',
                },
            },
        },
        variants: {
            text: ({ctaColor, isAnimated, animationTime, size}) => ({
                linkWrapper: {
                    py: remCalc(7),
                    pb: remCalc(8),
                    px: remCalc(5),
                    background: 'color.background.transparent',
                    textStyle: buttonSizes[size] || 'buttonMd',
                    fontWeight: 400,
                    minHeight: 'fit-content',
                    width: 'fit-content',
                    color: ctaColor ?? 'color.text.black',
                    _after: {
                        content: '""',
                        pos: 'absolute',
                        width: '100%',
                        h: remCalc(1),
                        bottom: remCalc(1),
                        left: 0,
                        bg: ctaColor ?? 'color.text.black',
                        animation: isAnimated ? `${animationUnderlineAfter} ${animationTime}ms cubic-bezier(.25,.1,.25,1) forwards` : 'none',
                    },
                    _hover: {
                        bg: 'color.background.transparent',
                    },
                },
            }),
            button: ({background, ctaColor, hoverBackground, hoverCtaColor, borderColor, size}) => ({
                linkWrapper: {
                    p: remCalc(13),
                    textStyle: buttonSizes[size] || 'buttonSm',
                    minW: `min(100%, ${remCalc(280)})`,
                    maxW: '100%',
                    borderWidth: remCalc(1),
                    textAlign: 'center',
                    justifyContent: 'center',

                    color: ctaColor ?? 'color.text.white',
                    bg: background ?? 'color.background.alpha.light.30',
                    borderColor: borderColor,

                    _hover: {
                        bg: hoverBackground ?? 'color.background.white',
                        color: hoverCtaColor ?? 'color.text.black',
                    },
                },
            }),
            outline: ({ctaColor, borderColor, size}) => ({
                linkWrapper: {
                    p: remCalc(13),
                    textStyle: buttonSizes[size] || 'buttonSm',
                    minW: `min(100%, ${remCalc(280)})`,
                    maxW: '100%',
                    borderWidth: remCalc(1),
                    textAlign: 'center',
                    justifyContent: 'center',

                    color: ctaColor ?? 'color.text.black',
                    borderColor: borderColor ?? 'color.text.black',
                },
            }),
            textBorderTop: ({ctaColor, layout_text_below_image, size}) => ({
                linkWrapper: {
                    py: remCalc(7),
                    pb: remCalc(8),
                    px: remCalc(5),
                    background: 'color.background.transparent',
                    textStyle: buttonSizes[size] || 'buttonMd',
                    fontWeight: 400,
                    minHeight: 'fit-content',
                    width: 'fit-content',
                    color: ctaColor ?? 'color.text.black',
                    textTransform: 'none',
                },

                linkText: {
                    textStyle: 'displayXs',
                    position: 'relative',
                    _before: {
                        content: "''",
                        display: layout_text_below_image ? 'none' : 'block',
                        position: 'relative',
                        zIndex: 1,
                        width: remCalc(32),
                        height: '2px',
                        background: ctaColor ? ctaColor : 'color.text.white',
                        left: '50%',
                        top: '-2px',
                        transform: 'translateX(-50%)',
                    },
                },
            }),
        },
        defaultProps: {
            variant: 'text',
        },
    },
}
export default ctaButton
